<template>
  <v-dialog v-model="dialog" max-width="700" :fullscreen="isMobile()">
    <v-card>
      <toolbar-card-visita :opcao_checklist="checklist" />
      <v-card-text class="pt-5">
        <slider-imagens-visita categoria="fezes" />

        <v-row class="mt-4">
          <v-col cols="12">
            <v-textarea
              rows="5"
              outlined
              label="Observações fezes"
              placeholder="Ex.: cor, consistência, cheiro, presença de sangue, muco ou outros aspectos das fezes."
              persistent-placeholder   
              v-model="visita.obs_fezes"           
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <btn-salvar-dados-visita />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
import ToolbarCardVisita from "./ToolbarCardVisita.vue";
import SliderImagensVisita from "./SliderImagensVisita.vue";
import { mapState } from 'vuex';
export default {
  components: { ToolbarCardVisita, BtnSalvarDadosVisita, SliderImagensVisita },
  computed: {
    ...mapState("visitaTecnica",["visita"])
  },
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  data: () => ({
    dialog: false,
    checklist: {
      descricao: "Avaliação das Fezes",
      icone: "mdi-clipboard-text-outline",
    },    
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>